import { ChallengerCore } from "../core";
import { Cdata } from "../structs";
import { Utils } from "../utils";

export class Challenge {
    static readonly IMAGEDATA: string = "data:image/png;base64, ";
    static readonly EXPECTED_MEDIA_LENGTH = 2;

    cdata: Cdata;
    cdata_status: number;

    private cres_element: HTMLInputElement | null; // The element which should contain the Challenge result
    protected mdata: string;

    protected core: ChallengerCore;

    constructor(core: ChallengerCore, cdata: Cdata, cdata_status: number, mdata: string) {
        this.core = core;
        this.cdata = cdata;
        this.cdata_status = cdata_status;
        this.mdata = mdata;
        this.cres_element = null;
    }

    // execute - should be overloaded and used to perform the "thinking" of the Challenge
    protected async execute(): Promise<boolean> { return true; }
    // render - should be overloaded and used to add elements to the page
    async render(parentDiv: HTMLElement): Promise<boolean> {
        parentDiv.innerHTML = "";
        return true;
    }
    // processMdata - should be overloaded and used to parse the this.mdata value that has already already been loaded
    protected processMdata(): boolean { return true; }

    // getMedia - Gets the the Media data for the Challenge from the Challenger API
    protected async getMedia(): Promise<boolean> {
        const cid = this.cdata.result.cid;
        const url = `/m?cid=${cid}&mtype=0`;

        return Utils.cFetch(this.core.conf.capi, url, "GET", null, this.core.conf.trackingID)
            .then((response) => {
                if (!response.ok) { return false; }
                return response.text().then((resp) => {
                    this.mdata = resp;
                    return true;
                });
            })
            .catch(() => {
                return false;
            });
    }

    // Gets the cres input element for this challenge
    // If it does not exist, a 'default' one is created
    protected getCresElement(): HTMLInputElement {
        if (!this.cres_element) {
            const cres = window.document.createElement("input") as HTMLInputElement;
            cres.type = "hidden";
            cres.value = "";
            this.cres_element = cres;
        }
        return this.cres_element;
    }

    // Returns the current result of the challenge and if login / formsubmit should be blocked
    // Can be overloaded in case of more complex cases
    getChallengeResult(): [string, boolean] {
        return [this.getCresElement().value, false];
    }

    protected insertAfter(newNode: HTMLElement, referenceNode: HTMLElement): void {
        if (referenceNode.parentNode) {
            referenceNode.parentNode.insertBefore(newNode, referenceNode.nextSibling);
        }
    }

    // Format function for replacing markers in localized strings
    protected format(str: string, data: string[] | number[]): string {
        const replacer = function (match: string): string {
            const replace_index = match.replace(/{/, "").replace(/}/, "");
            const replace_index_int = parseInt(replace_index, 10);
            let replacement = "";

            if (replace_index_int < data.length) {
                let value = data[replace_index_int];
                if (typeof value === "number") {
                    value = value.toString();
                }
                replacement = value;
            }

            return replacement || match;
        };

        str = str.replace(/{\d+}/g, replacer);
        return str;
    }
}

export type ValidatePhoneFunc = (phone: string) => boolean;
